<div
  class="relative p-[10px] border-transparent max-w-[400px] w-[100%] cursor-pointer"
  [id]="'pagemodule' + content.id"
  [ngStyle]="{
    backgroundColor: styles.colors['other']['background'],
  }"
  [ngClass]="{
    '!shadow-[0px_0px_2px_2px] !shadow-primary': isSelectedModule,
  }">
  <div class="my-5">
    <div
      class="text-center font-bold mb-5"
      [attr.style]="buildStyle('text', items[0].styles?.text)">
      {{ items[0].value.text }}
    </div>

    <div>
        @for (file of filter(items, 'type', 'downloadable-file'); track file) {
          <div class="mb-2 bg-light px-4 py-1 rounded-md flex items-center justify-between border-2 border-solid border-primary">
            <div>{{ file?.value?.label }}</div>
            <div>
                <p-button icon="pi pi-download" [text]="true" (click)="downloadFile(file?.value?.url)" />
            </div>
          </div>
        }
    </div>
  </div>
</div>